import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { products as productsAPI } from 'api';
import { getAddProductApiHOC } from '../selectors';

export const getIsFetching = state => getAddProductApiHOC(state).isFetching;

export default combineReducers({
  isFetching: handleActions({
    [productsAPI.types.POST_PRODUCT_REQUEST]: () => true,
    [productsAPI.types.POST_PRODUCT_SUCCESS]: () => false,
    [productsAPI.types.POST_PRODUCT_FAILURE]: () => false,
  }, false),
});



// WEBPACK FOOTER //
// ./src/components/apiHOCs/AddProductApiHOC/reducers.js